import { createApp } from 'vue';

import index from './index.vue';

let instance;
let isInstanced = false;
let parent = document.createElement('div');
let appDom = document.getElementById('app');

export default {
  install(app) {
    const Helper = () => {
      return new Promise((resolve, reject) => {
        if (isInstanced) {
          reject('Helper is already open');
          return;
        }
        isInstanced = true;
        instance = createApp(index);
        instance.config.globalProperties.callback = (obj) => {
          if (obj) {
            resolve(true);
          } else {
            reject(false);
          }
          isInstanced = false;
          instance.unmount(parent);
          appDom.removeChild(parent);
        };
        const { $service, JSON_HEADER, $store, $sendAction, $route } = app.config.globalProperties;
        instance.config.globalProperties.$service = $service;
        instance.config.globalProperties.$JSON_HEADER = JSON_HEADER;
        instance.config.globalProperties.$store = $store;
        instance.config.globalProperties.$sendAction = $sendAction;
        instance.config.globalProperties.$route = $route;
        appDom.appendChild(parent);
        instance.mount(parent);
      });
    };
    app.config.globalProperties.$helper = Helper;
  },
};
